export const getVideoUrl = (item) => {
  if (item?.videoUrl) return item.videoUrl;
  if (item?.videos?.length > 0) return item.videos[0]?.url || item.videos[0]?.videoUrl || "";
  return "";
};

export const getImageUrl = (item) => {
  if (item?.imageUrl) return item.imageUrl;
  if (item?.images?.length > 0) return item.images[0]?.thumbnailUrl || item.images[0]?.url || "";
  if (item?.videos?.length > 0) return item.videos[0]?.thumbnailUrl || "";
  return "";
};